import { styled } from "@mui/material";
import { useMessageBoxContext } from "@src/MessageBoxView/context/MessageBoxContext";

import { MessageBox } from "../components/MessageBox";

export const MessageBoxPopupWidget1 = styled(MessageBox)(() => {
  const { widget } = useMessageBoxContext();

  return {
    borderRadius: widget.styles.container.cornerRadius,
  };
});
